import styled from "styled-components";
import theme from "../../theme/ThemeProvider.styled";

const PageText = styled.p`
margin-bottom: 2rem;
color: ${theme.black};
`;

export default PageText;
